// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"dca80980","453":"558f804b","613":"9f12fd88"}[chunkId] + ".chunk.js";
};